// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d2c71db6","648":"ebdb2cf2"}[chunkId] + ".chunk.js";
};